import { render } from "./ModalInfo.vue?vue&type=template&id=7c67b427&scoped=true&ts=true"
import script from "./ModalInfo.vue?vue&type=script&lang=ts"
export * from "./ModalInfo.vue?vue&type=script&lang=ts"

import "./ModalInfo.vue?vue&type=style&index=0&id=7c67b427&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c67b427"]])

export default __exports__